module.exports = {"username":"Brûkersnamme","password":"Wachtwurd","login":"Ynlogge","errors":{"username-required":"Brûkersnamme is ferplichte en mei net leech wêze","password-required":"Wachtwurd is ferplichte en mei net leech wêze","4c6e7474-1892-43f3-baf9-b8a8b9ea2be5":"Brûkersnamme of wachtwurd net fûn"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/fy/login-form.json
// module id = WKuk
// module chunks = 1